import React, { useState } from 'react';
import { Stack, Button, Typography } from '@mui/material';
import CustomerDetailsForm from './CustomerDetailsForm';
import Utils from '../../core/Utils';
import ConfirmPopup from '../common/ConfirmPopup';
// import ConfirmPopup from '../common/ConfirmPopup'; // Uncomment if you have it

const initialCustomer = {
    customerBillingName: '',
    customerBillingAddress: '',
    customerBillingGSTNumber: '',
    customerBillingMobileNumber: '',
};

const CustomerDetailsList = ({
    customers,
    setCustomers,
    handleDeleteCustomer,
}) => {
    const [currentCustomer, setCurrentCustomer] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmText, setConfirmText] = useState('');

    const handleAddNew = () => {
        setCurrentCustomer({ ...initialCustomer });
        setShowForm(true);
    };

    const handleCustomerChange = (updatedCustomer) => {
        setCurrentCustomer(updatedCustomer);
    };

    const handleCustomerComplete = (customer) => {
        const existingCount = (customers || []).filter(
            (c) =>
                c.customerBillingMobileNumber === customer.customerBillingMobileNumber
        ).length;

        if (existingCount >= 5) {
            setConfirmText('This customer can only be added up to 5 times.');
            setConfirmOpen(true);
            return;
        }

        setCustomers([...(customers || []), customer]);
        setCurrentCustomer(null);
        setShowForm(false);
    };

    const handleConfirmClose = () => setConfirmOpen(false);

    return (
        <Stack spacing={3}>

            <ConfirmPopup
                confirmOpen={confirmOpen}
                confirmText={confirmText}
                onConfirmClose={handleConfirmClose}
            />

            <Typography
                level="h3"
                component="h3"
                fontWeight="600"
                fontSize="2rem"
                className="h3"
            >
                Address Details
            </Typography>

            {!Utils.IsNullOrEmptyArray(customers) &&
                customers.map((cust, idx) => (
                    <CustomerDetailsForm
                        key={idx}
                        customer={cust}
                        onChange={(updated) => {
                            const updatedList = [...customers];
                            updatedList[idx] = updated;
                            setCustomers(updatedList);
                        }}
                        onComplete={(updated) => {
                            const updatedList = [...customers];
                            updatedList[idx] = updated;
                            setCustomers(updatedList);
                        }}
                        onDelete={() => handleDeleteCustomer(cust)}
                    />
                ))}

            {showForm ? (
                <CustomerDetailsForm
                    customer={currentCustomer}
                    onChange={handleCustomerChange}
                    onComplete={handleCustomerComplete}
                    isNew={true}
                    onCancel={() => {
                        setCurrentCustomer(null);
                        setShowForm(false);
                    }}
                />
            ) : (
                <Button variant="outlined" onClick={handleAddNew}>
                    + Add New Address Details
                </Button>
            )}
        </Stack>
    );
};

export default CustomerDetailsList;
